import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';
import getCurrentBreakpoint, { onBreakpointChange } from '@project/shared/utils/breakpoints/js/breakpoints';

const widthOfArrow = 22,
	paddingReserve = 0,
	classes = {
		body: 'body',
		stateActive: 'state-m-navigation-meta__item--active',
		layerOpener: 'js-m-navigation-wrapper__item-level1',
		widthCalculationBase: 'js-header-content',
		navigationLayerWrapper: 'js-m-navigation-wrapper__layer',
		level1OpenLayer: 'js-m-navigation-wrapper__open-layer',
		sitesOpener: 'js-m-navigation-meta__flyout-trigger',
		stateSitesActive: 'state-m-navigation-meta__sites--active',
		sitesFlyout: 'js-m-navigation-meta__flyout',
		countryRegion: 'js-m-navigation-meta__region',
		openCountryRegion: 'js-m-navigation-meta__open-region',
		countryContainer: 'js-m-navigation-wrapper__country-container',
		loginElement: 'js-m-navigation-meta__item--login',
		logedinState: 'state-m-navigation-meta__item--loggedin',
		loginUsername: 'js-m-navigation-meta__username',
		positionFixer: 'm-navigation-meta__flyout--position-fixer',
		navigationFavouriteTooltip: 'm-navigation-meta__tooltip-favourite',
		tooltipCloser: 'js-m-tooltip__closer'
	};

let isDesktopNavigationInitialized = false;

@createModule('NavigationMeta')
/**
 * navigation-meta module implementation.
 *
 * @author Nele Rabus <nele.rabus@namics.com>
 */
export class NavigationMeta extends TerrificSpec {
	metaNaviFlyout: JQuery;
	initiallyMeasured: boolean = false;
	$ctx: JQuery;
	$loginElement: JQuery;
	$loginUsername: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.metaNaviFlyout = $(`.${classes.sitesFlyout}`);

		this.initNavigationOpening();
		this.initNavigationPositioning();
		$(window).resize(() => this.initNavigationPositioning());
		onBreakpointChange(() => this.initNavigationOpening());

		this.$ctx.find('.js-search-trigger').on('click', (event: Event) => {
			this._handleTrigger(event);
		});

		$(`.${classes.tooltipCloser}`).on('click', () => {
			$(`.${classes.tooltipCloser}`).parents('.m-tooltip').fadeOut();
		});

		this.initUserStatus();

		this.initFavTooltip();

		resolve();
	}

	stop() {}

	_triggerChangeEvent() {
		triggerPublicEvent(PublicEvents.uxChange, this, this._ctx);
	}

	initFavTooltip() {
		$(`.${classes.navigationFavouriteTooltip}`).on('click', (ev: Event) => {
			ev.stopPropagation();
		});
		$(`.${classes.navigationFavouriteTooltip}`).prev(`.${classes.level1OpenLayer}`).on('click', () => {
			if($(`.${classes.navigationFavouriteTooltip}`).css('display') == 'block') {
				$(`.${classes.navigationFavouriteTooltip}`).fadeOut();
			}
		});
		$('html').on("click", () => {
			if($(`.${classes.navigationFavouriteTooltip}`).css('display') == 'block') {
				$(`.${classes.navigationFavouriteTooltip}`).fadeOut();
			}
		});
	}

	initUserStatus() {
		this.$loginElement = this.$ctx.find(`.${classes.loginElement}`);
		this.$loginUsername = this.$ctx.find(`.${classes.loginUsername}`);
		const serviceUrl = this.$loginElement.data('userstatus-service');
		if (serviceUrl) {
			$.ajax({
				method: 'get',
				url: serviceUrl,
				success: this.onUserStatusAjaxSuccess.bind(this),
			});
		}
	}

	onUserStatusAjaxSuccess(data: any) {
		if (data.login) {
			this.$loginElement.addClass(classes.logedinState);
			if(data.FirstName == null && data.FirstName==null){
				return;
			}
			var firstName = "";
			var lastName = "";

			if(data.FirstName != null){
				firstName = data.FirstName;
			}
			if(data.LastName != null){
				lastName = data.LastName;
			}

			this.$loginUsername.html(firstName+" "+lastName);
		}
	}

	_handleTrigger(event: Event) {
		event.preventDefault();
		event.stopPropagation();
		$('.a-search-trigger__item-link.js-search-trigger').click();
	}

	// calculate the position of each flyout in viewport large and extra-large
	initNavigationPositioning() {
		const $ctx = $(this._ctx),
			viewport = getCurrentBreakpoint() as string;

		if (viewport === 'large' || viewport === 'extra-large') {
			$(`.${classes.layerOpener} > .${classes.level1OpenLayer}`, $ctx).each(function() {
				const currentFirstLevelNavigationElement = $(this);
				const currentFirstLevelNavigationFlyout = currentFirstLevelNavigationElement
					.parent()
					.find(`.${classes.navigationLayerWrapper}`);

				// in case there is a full width layout, the flyout will be set to left:0 , what is the correct positioning
				const positionOfFirstLevelNavigationElement = currentFirstLevelNavigationElement.position();
				const paddingLeftOfFirstLevelNavigationElement = parseFloat(
					currentFirstLevelNavigationElement.css('padding-left')
				);
				const widthOfOfFirstLevelNavigationElement = currentFirstLevelNavigationElement.width();
				const centerPositionOfNavElement =
					positionOfFirstLevelNavigationElement.left + widthOfOfFirstLevelNavigationElement / 2;
				const widthOfFlyout = currentFirstLevelNavigationFlyout.width();
				let leftOfFlyout =
					centerPositionOfNavElement -
					widthOfFlyout / 2 +
					widthOfArrow / 2 +
					paddingLeftOfFirstLevelNavigationElement / 2;
				const rightOfFlyout = leftOfFlyout + widthOfFlyout;
				const totalUsuableWidth = $(`.${classes.widthCalculationBase}`).width();

				// => flyout would reach over right border
				if (rightOfFlyout > totalUsuableWidth) {
					leftOfFlyout = totalUsuableWidth - widthOfFlyout - paddingReserve;
				}

				// => flyout would reach over left border
				if (leftOfFlyout < 0) {
					leftOfFlyout = 0 + paddingReserve;
				}

				// set 'left' position
				currentFirstLevelNavigationFlyout.css('left', leftOfFlyout);
			});
		}
	}

	initDesktopNavigation(
		navigationItemLinks: JQuery,
		sitesOpenerElement: JQuery,
		countryRegions: JQuery,
		countryContainer: JQuery,
		sitesFlyout: JQuery
	) {
		navigationItemLinks.each((i: number, elem: HTMLElement) => {
			$(elem)
				.find(`.${classes.level1OpenLayer}`)
				.on('click.DesktopNavigationLink', (clickEvent: Event) => {
					const $el = $(elem);
					const isOpen = $el.hasClass(classes.stateActive);
					navigationItemLinks.removeClass(classes.stateActive);
					$el.toggleClass(classes.stateActive, !isOpen);
					clickEvent.preventDefault();
					clickEvent.stopPropagation();
				});
		});

		countryRegions.each((i: number, elem: HTMLElement) => {
			$(elem)
				.find(`.${classes.openCountryRegion}`)
				.on('click.DesktopCountrySitesRegionLink', (clickEvent: Event) => {
					this.activateRegionAndSetHeight($(elem), countryRegions, countryContainer);
					this.setHeaderMargin(sitesFlyout[0].offsetHeight);
					clickEvent.preventDefault();
					clickEvent.stopPropagation();
				});
		});

		countryRegions.removeClass(classes.stateActive);

		sitesOpenerElement.on('click.DesktopSitesNavigationLink', (clickEvent: Event) => {
			this.toggleSitesNavigation(sitesFlyout);

			if (!this.initiallyMeasured) {
				this.activateRegionAndSetHeight($(countryRegions[0]), countryRegions, countryContainer);
				this.setHeaderMargin(sitesFlyout[0].offsetHeight);
				this.initiallyMeasured = true;
			}
			clickEvent.preventDefault();
			clickEvent.stopPropagation();
		});

		$(window).on('resize.DesktopNavigationMetaResize', () => {
			if ($(classes.body).hasClass(classes.stateSitesActive)) {
				this.setHeaderMargin(sitesFlyout[0].offsetHeight);
			}
		});

		isDesktopNavigationInitialized = true;
	}

	destroyDesktopNavigation(navigationItemLinks: JQuery, sitesOpenerElement: JQuery, countryRegions: JQuery) {
		this.closeSitesNavigation();

		navigationItemLinks.each((i: number, elem: HTMLElement) => {
			$(elem)
				.find(`.${classes.level1OpenLayer}`)
				.off('click.DesktopNavigationLink');
			const currentFirstLevelNavigationElement = $(elem);
			const currentFirstLevelNavigationFlyout = currentFirstLevelNavigationElement
				.parent()
				.find(`.${classes.navigationLayerWrapper}`);

			currentFirstLevelNavigationElement.removeClass(classes.stateActive);
			currentFirstLevelNavigationFlyout.css('left', '');
		});

		countryRegions.each((i: number, elem: HTMLElement) => {
			$(elem)
				.find(`.${classes.openCountryRegion}`)
				.off('click.DesktopCountrySitesRegionLink');
		});

		sitesOpenerElement.off('click.DesktopSitesNavigationLink');
		$(window).off('scroll.DesktopNavigationMetaNavigationScrolling');
		$(window).off('resize.DesktopNavigationMetaResize');

		isDesktopNavigationInitialized = false;
	}

	initNavigationOpening() {
		const $ctx = $(this._ctx),
			viewport = getCurrentBreakpoint() as string,
			navigationItemLinks = $(`.${classes.layerOpener}`, $ctx),
			sitesOpenerElement = $(`.${classes.sitesOpener}`, $ctx),
			countryRegions = $(`.${classes.countryRegion}`, $ctx),
			countryContainer = $(`.${classes.countryContainer}`, $ctx),
			sitesFlyout = $(`.${classes.sitesFlyout}`, $ctx);

		if (viewport === 'medium' || viewport === 'small') {
			this.destroyDesktopNavigation(navigationItemLinks, sitesOpenerElement, countryRegions);
		} else if (!isDesktopNavigationInitialized) {
			this.initDesktopNavigation(
				navigationItemLinks,
				sitesOpenerElement,
				countryRegions,
				countryContainer,
				sitesFlyout
			);
		}
	}

	setHeaderMargin(margin: number) {
		$(window).trigger('setHeaderMargin', [margin]);
	}

	toggleSitesNavigation(sitesFlyout: JQuery) {
		// Bug: COVDCJMCP-1409
		// toggling 'classes.stateSitesActive' in necessary as in Win8 and 10, IE11 a flickering/shine through of the
		// slider appears, in case it is (partly) covered by the header.
		// for further information read about: 'transform breaking position: fixed'
		// as I did not see any posibility to work without the transformation, fixed positioning without going too deep,
		// I opted for: setting the in this case the class 'm-navigation-meta__flyout--position-fixer' with a display: none
		if ($(classes.body).hasClass(classes.stateSitesActive)) {
			this.addClassWithTimeout(classes.positionFixer);
			this.setHeaderMargin(0);
			$('html').removeClass('no-scrolling--without-scrollbar');
			$(window).trigger('disablePreventStickyScrollBehaviour');
		} else {
			this.metaNaviFlyout.removeClass(classes.positionFixer);
			this.setHeaderMargin(sitesFlyout[0].offsetHeight);
			$('html').addClass('no-scrolling--without-scrollbar');
			$(window).trigger('enablePreventStickyScrollBehaviour');
		}
		$(classes.body).toggleClass(classes.stateSitesActive);
	}

	closeSitesNavigation() {
		this.addClassWithTimeout(classes.positionFixer);
		this.setHeaderMargin(0);
		$(classes.body).removeClass(classes.stateSitesActive);
	}

	activateRegionAndSetHeight(elem: JQuery, countryRegions: JQuery, countryContainer: JQuery) {
		countryRegions.removeClass(classes.stateActive);
		$(elem).addClass(classes.stateActive);
		countryContainer.css('min-height', $(elem).find(`.${classes.navigationLayerWrapper}`)[0].offsetHeight + 'px');
	}

	addClassWithTimeout(classname: string) {
		window.setTimeout(() => {
			this.metaNaviFlyout.addClass(classname);
		}, 700);
	}
}
